import { getQueryParam } from "../utils/routing/Url";

export const useIsEmbedded = () => {
  const hasInstallUid = !!getQueryParam("verificationIframeUid");
  return { isEmbedded: hasInstallUid };
};
